import React from 'react'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import ArrowBackVariantIcon from '@material-ui/icons/KeyboardBackspace'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

export const LayoutMain = ({ children, className, wide = false }) => (
  <div
    className={cx(className, 'w-100',
      { pa0: wide }
    )}
  >
    {children}
  </div>
)

export const LayoutHeader = ({ title, children, spacing = 1, cxNames = 'pv2 mh2' }) => (
  <div className={cx(cxNames)}>
    <Grid
      container spacing={spacing} justify='space-between' alignItems='center'
      className={cx('bg-dark-sea-green-3 pv1 ph3 mt6 mb5')}
    >
      <Grid item className='fw7 f5 f6-m mv4 ml5 white tc-m'>
        {title}
      </Grid>
      <Grid item className='fw6 f6 f7-m'>
        {children}
      </Grid>
    </Grid>
  </div>
)

export const HeaderAction = ({ icon, onClick, description, href = null, target }) => (
  <TealToolTip title={description} placement='top' leaveDelay={300}>
    <Link {...{ href, onClick, target }}>
      <IconButton size='small' classes={{ sizeSmall: 'pa3', disabled: 'grey' }}>
        <Icon name={icon} className='white w7' />
      </IconButton>
    </Link>
  </TealToolTip>
)

export const HeaderActionGroup = ({ icon, children }) => (
  <div className='flex relative'>
    {children}
  </div>
)

export const LayoutHistoryBack = ({
  onClick = () => history.back(),
  label = 'Back to previous screen',
  cxNames,
  href
}) => (
  <div className='w-max-content mt6'>
    <a
      {...{ href }}
      onClick={href ? undefined : onClick}
      className={cx('flex items-center pointer no-underline hover-underline', cxNames)}
    >
      <ArrowBackVariantIcon />
      <span className='ml2 f6'>{label}</span>
    </a>
  </div>
)
